import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { timezoneToUtc } from '../../../util/tstamp';
import PPDChart from './PPDChart';
import { getAggDataURL, getPPDDataURL } from '../../../util/urlApi';
import { DATETIME_FORMAT, TIME_FORMAT_WITH_SECONDS } from '../../../util/constants';

const PhasePPD = (props) => {
  const {
    index,
    config
  } = props;
  const phases = useSelector(state => state.entities.pm.phases);
  const [ppdChart, set_ppdChart] = useState(null);
  useEffect(() => {
      const selectedPhase = phases[index];
      const direction = (selectedPhase.split('-')[0]).toUpperCase();
      const movement = selectedPhase.split('-')[1];
      const flow = selectedPhase.split('-')[2];
      const [apiUrlPPD, apiUrlAgg] = getApiUrl(config.startDate,
        config.endDate,
        config.intersectionId,
        config.intersectionTimezone,
        direction,
        movement,
        flow,
        config.checkedDow,
        config.todStart,
        config.todEnd);

      const chartTitle = `Phase ${index} - ${direction}, ${flow}`;
      set_ppdChart(<PPDChart
        ppdType={'single'}
        apiUrl={apiUrlPPD}
        movement={flow}
        direction={direction}
        apiUrlAgg={apiUrlAgg}
        aggData={props.aggData}
        ppdData={props.ppdData}
        isLoading={props.isLoading}
        chartTitle={chartTitle}
        chartWidth={500}
        chartHeight={500}
      />);

    },
    [phases, config.startDate, config.endDate, config.todStart, config.todEnd, props.aggData, props.ppdData]);
  return (
    <>
      {ppdChart}
    </>
  );
};

const getApiUrl = (startDate, endDate, intersectionId, intersectionTimezone, direction, movement, flow, checkedDow, todStart, todEnd) => {
  const startDateUTC = timezoneToUtc(startDate, intersectionTimezone)
  .format(DATETIME_FORMAT);
  const endDateUTC = timezoneToUtc(endDate, intersectionTimezone)
  .format(DATETIME_FORMAT);
  const todStartUTC = timezoneToUtc(`${startDate.split(' ')[0]} ${todStart}`, intersectionTimezone)
  .format(TIME_FORMAT_WITH_SECONDS);
  const todEndUTC = timezoneToUtc(`${startDate.split(' ')[0]} ${todEnd}`, intersectionTimezone)
  .add(-1, 'seconds')
  .format(TIME_FORMAT_WITH_SECONDS);
  const apiUrlPPD = getPPDDataURL(startDateUTC,
    endDateUTC,
    intersectionId,
    checkedDow,
    todStartUTC,
    todEndUTC);
  const apiUrlTraj = getAggDataURL(startDateUTC,
    endDateUTC,
    [intersectionId,],
    checkedDow,
    todStartUTC,
    todEndUTC);

  return [apiUrlPPD, apiUrlTraj];
};

export default PhasePPD;
